module.exports = __webpack_public_path__ + "static/media/work-accent-light.4783f719.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/work-accent-light.svg
// module id = 702
// module chunks = 0